"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _mui = require("tss-react/mui");
var _Card = _interopRequireDefault(require("../Card"));
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _excluded = ["id"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BORDER_WIDTH = 2;
var useStyles = (0, _mui.makeStyles)()(function (theme, _params, classes) {
  return {
    grid: {
      marginTop: 0,
      marginBottom: 0
    },
    gridItem: {
      position: 'relative'
    },
    card: {
      margin: 0,
      padding: theme.spacing(3) - BORDER_WIDTH,
      boxSizing: 'border-box',
      border: "".concat(BORDER_WIDTH, "px solid transparent"),
      transition: 'border-color 0.25s, background-color 0.25s',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.lightGrey.light
      }
    },
    selected: {
      borderColor: theme.palette.green.main,
      opacity: 1
    },
    checkbox: _defineProperty({
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(3),
      zIndex: 1,
      color: theme.palette.primary.main
    }, "&.".concat(classes.checked), {
      color: theme.palette.primary.main
    }),
    checked: {}
  };
});
var SelectableCards = function SelectableCards(_ref) {
  var inputId = _ref.id,
    cards = _ref.cards,
    value = _ref.value,
    multiple = _ref.multiple,
    handleChange = _ref.handleChange,
    gridItemProps = _ref.gridItemProps,
    required = _ref.required,
    cardClassName = _ref.classes.card;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var onClick = function onClick(id) {
    return function () {
      if (multiple && !required) {
        var newValue = _toConsumableArray(value);
        var index = newValue.indexOf(id);
        if (index === -1) newValue.push(id);else newValue.splice(index, 1);
        handleChange(newValue);
      } else if (multiple && required) handleChange(id);else if (required) handleChange(id);else handleChange(id === value ? undefined : id);
    };
  };
  var isSelected = function isSelected(id) {
    return value === id || Array.isArray(value) && value.includes(id);
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    spacing: 4,
    container: true,
    id: inputId,
    className: classes.grid
  }, cards.map(function (_ref2) {
    var id = _ref2.id,
      card = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], _extends({
      item: true,
      key: id
    }, gridItemProps, {
      className: classes.gridItem
    }), multiple && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      classes: {
        root: classes.checkbox,
        checked: classes.checked
      },
      checked: isSelected(id),
      onChange: onClick(id)
    }), /*#__PURE__*/_react["default"].createElement(_Card["default"], _extends({}, card, {
      className: cx(classes.card, isSelected(id) && classes.selected, cardClassName),
      onClick: onClick(id)
    })));
  }));
};
SelectableCards.propTypes = {
  id: _propTypes["default"].string,
  cards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    children: _propTypes["default"].node
  })).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  handleChange: _propTypes["default"].func.isRequired,
  required: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  gridItemProps: _propTypes["default"].shape({
    xs: _propTypes["default"].number,
    sm: _propTypes["default"].number,
    md: _propTypes["default"].number,
    lg: _propTypes["default"].number,
    xl: _propTypes["default"].number
  }),
  classes: _propTypes["default"].shape({
    card: _propTypes["default"].string
  })
};
SelectableCards.defaultProps = {
  id: undefined,
  required: false,
  multiple: false,
  value: undefined,
  gridItemProps: {
    xs: 12,
    sm: 6,
    md: 4,
    lg: 3,
    xl: 2
  },
  classes: {}
};
var _default = (0, _withFormField["default"])({
  messagePosition: 'bottom'
})(SelectableCards);
exports["default"] = _default;